module.exports = __webpack_public_path__ + "img/f1-6.5c39e388.png";